import { useTranslation } from 'react-i18next'
import { LoginForm } from '@/features/auth/components/LoginForm'

export function LoginPage() {
  const { t } = useTranslation()

  return (
    <main className="min-h-screen bg-surface-50 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <h1 className="text-2xl font-semibold text-surface-900 mb-8 text-center">
          {t('auth.login_title')}
        </h1>
        <LoginForm />
      </div>
    </main>
  )
}
